import React from "react";

export const PageFooterHyperlink = ({ children, path }) => {
  return (
    <a className="page-footer__hyperlink" href={path}>
      {children}
    </a>
  );
};
